import { FC, useEffect } from "react";
import Typography from "@mui/material/Typography";
import { getSurveySection } from "app/features/surveySlice";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { FormControlModel } from "types";
import FormComponentFactory from "lib/factory/FormComponentFactory";
import { ElementType } from "lib/enums/enums";
import StepContent from "../StepContent";
import { TRUE, NO_SAVING } from "pages/SurveyForm/constants/uiControls";

type Props = {
  formik: any;
  sectionId: number;
};

const Step17: FC<Props> = ({ formik, sectionId }) => {
  const dispatch = useAppDispatch();
  const { surveySection } = useAppSelector((state) => state.survey) ?? [];
  const { questions = [] } = surveySection || {};

  useEffect(() => {
    dispatch(getSurveySection(sectionId));
  }, []);

  const clearPCS = (value: string) => {
    if (value === NO_SAVING) {
      formik.setFieldValue("pcsNames", []);
    }
  };

  const dataModel: Array<FormControlModel> = [
    {
      key: 0,
      formik,
      name: "policies",
      questionData: questions[0],
      elementType: ElementType.Checkbox,
      label: "¿Con cuáles polizas cuenta?",
      checkboxStyle: {
        minWidth: "200px",
        margin: "0 1rem",
      },
    },
    {
      key: 1,
      formik,
      visible: true,
      name: "hasPCS",
      questionData: questions[1],
      onChangeCallback: clearPCS,
      elementType: ElementType.Radio,
      label: "¿Cuenta con plan complementario de salud?",
    },
    {
      key: 2,
      formik,
      name: "pcsNames",
      label: "¿Cuál?",
      visible: formik?.values?.hasPCS?.value === TRUE,
      elementType: ElementType.Checkbox,
      questionData: questions[1]?.subQuestions[0],
      checkboxStyle: {
        minWidth: "300px",
        margin: "0 1rem",
      },
    },
  ];

  return (
    <div>
      <Typography mb={2} variant='subtitle1' align='left'>
        Cuéntenos más de usted: beneficios adicionales que puede recibir
      </Typography>
      <StepContent>{dataModel.map(FormComponentFactory)}</StepContent>
    </div>
  );
};

export default Step17;
